import config from "../../config.json";

(async () => {
  await Office.onReady();
  const AUTH0_DOMAIN = config.auth0_domain;
  const CLIENT_ID = config.client_id;
  const AUDIENCE = config.audience;

  const urlParams = new URLSearchParams(window.location.search);
  const action = urlParams.get("action");
  const code = urlParams.get("code");
  const email = urlParams.get("email");

  if (action === "login") {
    startAuthFlow(email ?? null);
  } else if (action === "logout") {
    logout();
  } else if (code) {
    const token = await handleRedirectCallback();
    if (token?.access_token) {
      Office.context.ui.messageParent(JSON.stringify(token));
    } else {
      Office.context.ui.messageParent("ERROR");
    }
  } else {
    Office.context.ui.messageParent("LOGOUT_SUCCESS");
  }

  async function startAuthFlow(email = null) {
    const { code_challenge, code_verifier } = await pkceChallenge();
    window.sessionStorage.setItem("verifier", code_verifier);
    const connection = config?.auth_connection ? config?.auth_connection : null;

    const params = new URLSearchParams({
      response_type: "code",
      client_id: CLIENT_ID,
      redirect_uri: window.location.origin,
      scope: "openid profile email offline_access",
      audience: AUDIENCE,
      code_challenge,
      code_challenge_method: "S256",
      ...(connection ? { connection } : email ? { login_hint: email } : {}),
    });

    const authUrl = `${AUTH0_DOMAIN}/authorize?${params.toString()}`;
    window.location.href = authUrl;
  }

  function logout() {
    const params = new URLSearchParams({
      client_id: CLIENT_ID,
      returnTo: config.HOST_URL,
    });
    const logoutUrl = `${AUTH0_DOMAIN}/v2/logout?${params.toString()}`;
    window.location.href = logoutUrl;
  }

  async function handleRedirectCallback() {
    const code = urlParams.get("code");
    const verifier = window.sessionStorage.getItem("verifier");

    const response = await fetch(`${AUTH0_DOMAIN}/oauth/token`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        grant_type: "authorization_code",
        client_id: CLIENT_ID,
        code_verifier: verifier,
        code,
        redirect_uri: window.location.origin,
      }),
    });

    const result = await response.json();
    return result;
  }

  async function pkceChallenge() {
    const encoder = new TextEncoder();
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    const code_verifier = Array.from(array, (byte) => ("0" + byte.toString(16)).slice(-2)).join("");

    const data = encoder.encode(code_verifier);
    const digest = await window.crypto.subtle.digest("SHA-256", data);

    const code_challenge = btoa(String.fromCharCode(...new Uint8Array(digest)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");

    return { code_verifier, code_challenge };
  }
})();
